<template>
    <div class="app-container">
        <Navbar />

        <main class="main-content">
            <router-view v-slot="{ Component }">
                <keep-alive :include="['BusquedaProductos', 'BusquedaAvanzada', 'Home', 'DDP', 'DiagramSelector','CarritoComponent','ListadoProductosLinea','TopVentas']">
                    <component :is="Component" :key="$route.name" />
                </keep-alive>
            </router-view>
        </main>

        <Footer />
    </div>
</template>

<script>
import Navbar from './components/App/Home/Header/Navbar.vue';
import Footer from './components/App/Home/Footer/Footer.vue';

export default {
    name: "App",
    components: { Navbar, Footer },

    data() {
        return {
            isLoggedIn: false,
            isMobile: false,
            isStandalone: false,
        };
    },

    created() {
        if (window.Laravel?.isLoggedin) {
            this.isLoggedIn = true;
        }

        const garageOperativo = localStorage.getItem('garage_operativo');
        const garageInvitado = localStorage.getItem('mi_garage');

        if (garageOperativo) {
            this.$store.commit(
                'setGarageOperativo',
                JSON.parse(garageOperativo)
            );
        }

        if (garageInvitado) {
            this.$store.commit(
                'setGarageGuest',
                JSON.parse(garageInvitado)
            );
        }
    },
    mounted() {
        this.$nextTick(() => {
            const navbar = document.getElementById('main-navbar');
            if (!navbar) return;

            this.syncNavbarHeight();

            this.resizeObserver = new ResizeObserver(() => {
                this.syncNavbarHeight();
            });

            this.resizeObserver.observe(navbar);

            window.addEventListener('resize', this.syncNavbarHeight, { passive: true });
        });
    },

    beforeUnmount() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
        window.removeEventListener('resize', this.syncNavbarHeight);
    },

    methods: {
        syncNavbarHeight() {
            const navbar = document.getElementById('main-navbar');
            if (!navbar) return;

            const rect = navbar.getBoundingClientRect();
            const fullHeight = rect.height;

            document.documentElement.style.setProperty(
                '--navbar-height',
                `${Math.ceil(fullHeight)}px`
            );
        },

        detectMobile() {
            return /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop|BlackBerry/i.test(
                navigator.userAgent
            );
        },

        detectStandalone() {
            return (
                window.matchMedia('(display-mode: standalone)').matches ||
                window.navigator.standalone
            );
        },

        logout(e) {
            e.preventDefault();
            this.$axios.get('/sanctum/csrf-cookie').then(() => {
                this.$axios.post('/logout')
                    .then(response => {
                        if (response.data.success) {
                            window.location.href = "/home";
                        }
                    })
                    .catch(error => {
                        console.error(error);
                    });
            });
        }
    }
};
</script>

<style scoped>
.app-container {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}

.main-content {
    flex: 1;
    padding-top: var(--navbar-height, 0px);
}

footer {
    padding: 10px;
    text-align: center;
    width: 100%;
    margin-top: auto;
}
</style>